import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import PositionedOverlayAnchor from '../PositionedOverlayAnchor/index.js';
import PositionedOverlayBase from '../PositionedOverlayBase/index.js';

/**
 * The PositionedOverlay component should be used to overlay content on top of a specific element.
 * The component comes with a few convenient "sub components":
 * PositionedOverlay.Base, PositionedOverlay.Anchor, with which you can build the PositionedOverlay.
 *
 */

function PositionedOverlay(_ref) {
  let {
    className,
    children,
    shrinkwrap = true,
    ...rest
  } = _ref;
  const rootClassName = clsx({
    'positioned-overlay': true
  }, className);
  const wrapperClassName = clsx({
    'positioned-overlay-wrapper': true,
    'positioned-overlay-shrinkwrap': shrinkwrap
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "positionedOverlay"
  }, rest, {
    className: rootClassName
  }), /*#__PURE__*/_jsx("div", {
    className: wrapperClassName
  }, void 0, children));
}
PositionedOverlay.Anchor = PositionedOverlayAnchor;
PositionedOverlay.Base = PositionedOverlayBase;
export default PositionedOverlay;